import { getDefaultLogonEmailAddress } from 'owa-session-store';
import { getOWAConnectedAccounts } from 'owa-accounts-store';
import type { IDropdownOption } from '@fluentui/react/lib/Dropdown';

/**
 * Returns array of dropdown options for accounts dropdown.
 */
export default function getAccountMenuOptions(dropdownItems: IDropdownOption[]) {
    dropdownItems.push(...getAccountOptions());
    return dropdownItems;
}

/**
 * Helper function to get accounts and convert them
 * to an array of IDropdownOption objects to get rendered.
 */
function getAccountOptions(): IDropdownOption[] {
    const dropdownItems: IDropdownOption[] = [];

    const primaryAccount = getDefaultLogonEmailAddress();

    // Add primary account as first option
    dropdownItems.push({
        key: primaryAccount,
        text: primaryAccount,
    });

    // Add connected accounts next
    const connectedAccounts = getOWAConnectedAccounts();
    connectedAccounts.map(account => {
        dropdownItems.push({
            key: account.userIdentity,
            text: account.userIdentity,
        });
    });

    return dropdownItems;
}
